// extracted by mini-css-extract-plugin
export default {"profileIcon":"profileIcon_profileIcon__DwGeK"};